import { render, staticRenderFns } from "./PacInfo.vue?vue&type=template&id=537a5e8a&scoped=true"
import script from "./PacInfo.vue?vue&type=script&lang=js"
export * from "./PacInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "537a5e8a",
  null
  
)

export default component.exports